<template>
	<div class="page">
		<div class="pageTitleBox">
			<div class="boxNameL">
				退换货订单详情
			</div>
			<div class="boxNameR">
				<el-button type="warning" @click="$router.back()" size="small">返回</el-button>
			</div>
		</div>
		<div class="msg" style="">
			<div class="msgItem">
				<div class="msgLabel">退单编号：</div>
				<div class="msgValue">
					{{detail.no}}
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">订单编号：</div>
				<div class="msgValue">{{detail.order_id}}</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">顾客：</div>
				<div class="msgValue">{{detail.user_info.nick_name}}</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">电话：</div>
				<div class="msgValue">
					{{detail.user_info.user_mobile}}
				</div>
			</div>
		</div>
		<div class="msg" style="">
			<div class="msgItem">
				<div class="msgLabel">退换方式：</div>
				<div class="msgValue">
					{{detail.return_type==1?'退货':''}}
					{{detail.return_type==2?'换货':''}}
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">订单类型：</div>
				<div class="msgValue">
					{{detail.source==1?'线上':''}}
					{{detail.source==2?'线下':''}}
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">是否入库：</div>
				<div class="msgValue">
					{{detail.is_into?'是':''}}
					{{!detail.is_into?'否':''}}
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">订单备注：</div>
				<div class="msgValue">
					<el-popover placement="top-start" width="200" trigger="hover" :content="detail.remark">
						<div slot="reference" style="display:inline-block;width:150px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;cursor: pointer;">{{detail.remark}}</div>
					</el-popover>
				</div>
			</div>
		</div>
		<div class="msg" style="">
			<div class="msgItem">
				<div class="msgLabel">订单状态：</div>
				<div class="msgValue">
					{{$public.formatOrderReturnState(detail.state)}}
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">总计：</div>
				<div class="msgValue">
					￥{{detail.total_price}}
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">创建人：</div>
				<div class="msgValue">
					{{detail.create_user_name}}
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">操作时间：</div>
				<div class="msgValue">
					{{$public.FTime(detail.create_time)}}
				</div>
			</div>
		</div>
		<div class="msg" style="">
			<div class="msgItem">
				<div class="msgLabel">结算方式：</div>
				<div class="msgValue">
					<span v-if="detail.pay_info">
						<span style="padding-right: 30px;" v-for="(item,index) in detail.pay_info.pay_list" :key="index">
							<span style="padding-right: 2px;">
								{{$public.formatPayTypeState(item.pay_type)}}
							</span>
							{{item.money}}
						</span>
					</span>
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">结算备注：</div>
				<div class="msgValue">
					<span v-if="detail.pay_info">
						{{detail.pay_info.pay_remark}}
					</span>
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">结算时间：</div>
				<div class="msgValue">
					<span v-if="detail.pay_info">
						{{$public.FTime(detail.pay_info.pay_time)}}
					</span>
				</div>
			</div>
		</div>
		<div class="pageConBox" v-if="detail._id">
			<el-row>
				<el-col>
					<span style="font-size: 14px;line-height: 35px;padding-left: 16px;">退货商品</span>
				</el-col>
			</el-row>
			<!-- 表格 -->
			<el-table :data="detail.return_list" max-height='800' style="width: 100%;margin-bottom: 20px;" row-key="tableKey"
			:tree-props="{children: 'goodsList', hasChildren: 'hasChildren'}">
				<el-table-column label="商品名称" width="220">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'赠品':scope.row.goodsName):
							scope.row.goodsName
						}}
					</template>
				</el-table-column>
				<el-table-column prop="bar_code" label="条码" width="150">
					<template slot-scope="scope">
						{{scope.row.goodsList?'':scope.row.bar_code}}
					</template>
				</el-table-column>
				<el-table-column label="规格" width="200">
					<template slot-scope="scope">
						{{
							scope.row.skuValue
						}}
					</template>
				</el-table-column>
				<el-table-column label="单位" width="80">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'':scope.row.unit):
							scope.row.unit
						}}
					</template>
				</el-table-column>
				<el-table-column prop="price" label="标准价" width="100">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'':scope.row.originalPrice):
							scope.row.originalPrice
						}}
					</template>
				</el-table-column>
				<el-table-column prop="activityName" label="活动" >
				</el-table-column>
				<el-table-column prop="price" label="优惠价" width="150">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'':scope.row.price):
							scope.row.price
						}}
					</template>
				</el-table-column>
				<el-table-column prop="num" label="数量" width="100">
				</el-table-column>
				<el-table-column label="总金额" width="120">
					<template slot-scope="scope">
						{{
							scope.row.totalMoney
						}}
					</template>
				</el-table-column>
				<el-table-column label="销售人员" width="120">
					<template slot-scope="scope">
						{{
							scope.row.staff
						}}
					</template>
				</el-table-column>
			</el-table>
			<el-row v-if="detail.replace_list.length" >
				<el-col>
					<span style="font-size: 22px;line-height: 35px;">换货商品</span>
				</el-col>
			</el-row>
			<!-- 表格 -->
			<el-table v-if="detail.replace_list.length" :data="detail.replace_list" max-height='800' style="width: 100%;margin-bottom: 20px;" row-key="tableKey"
			:tree-props="{children: 'goodsList', hasChildren: 'hasChildren'}">
				<el-table-column label="商品名称" width="320">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'赠品':scope.row.goodsName):
							scope.row.goodsName
						}}
					</template>
				</el-table-column>
				<el-table-column prop="bar_code" label="条码" width="150">
					<template slot-scope="scope">
						{{scope.row.goodsList?'':scope.row.bar_code}}
					</template>
				</el-table-column>
				<el-table-column label="规格" width="200">
					<template slot-scope="scope">
						{{
							scope.row.skuValue
						}}
					</template>
				</el-table-column>
				<el-table-column label="单位" width="80">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'':scope.row.unit):
							scope.row.unit
						}}
					</template>
				</el-table-column>
				<el-table-column prop="price" label="标准价" width="100">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'':scope.row.originalPrice):
							scope.row.originalPrice
						}}
					</template>
				</el-table-column>
				<el-table-column prop="activityName" label="活动" >
				</el-table-column>
				<el-table-column prop="price" label="优惠价" width="150">
					<template slot-scope="scope">
						{{
							scope.row.goodsList?
							(scope.row.gift=='gift'?'':scope.row.price):
							scope.row.price
						}}
					</template>
				</el-table-column>
				<el-table-column prop="num" label="数量" width="100">
				</el-table-column>
				<el-table-column label="总金额" width="120">
					<template slot-scope="scope">
						{{
							scope.row.totalMoney
						}}
					</template>
				</el-table-column>
				<el-table-column label="销售人员" width="120">
					<template slot-scope="scope">
						{{
							scope.row.staff
						}}
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				detail:{
					user_info:{},
					replace_list:[],
					return_list:[],
					pay_info:{},
					
				},
				orderDetail:{},
					tableData:[]
			}
		},
		mounted(){
			
			this.getOrederDetail();
		},
		methods: {
			getOrederDetail(){
				this.$http.get(process.env.VUE_APP_Url_order +
            "/api/OffLineOrder/" +
            this.$route.query.No).then((res) => {
          if (res.code == 0) {
            this.orderDetail = res.data;
            this.tableData = [];
            for (let i = 0; i < this.orderDetail.order_item_list.length; i++) {
              let one = {
                goodsId: this.orderDetail.order_item_list[i].goods_id, // 商品id
                goodsName: this.orderDetail.order_item_list[i].goods_name, // 商品名称
                goodsType: this.orderDetail.order_item_list[i].goods_type, // 1:商品；2:服务；3:套餐
                _id: this.orderDetail.order_item_list[i]._id,
                model: this.orderDetail.order_item_list[i].sku_value, // 规格
                skuValue: this.orderDetail.order_item_list[i].sku_value, // 规格
                barCode:this.orderDetail.order_item_list[i].bar_code,
                skus: this.orderDetail.order_item_list[i].skus_id, // 规格
                unit: this.orderDetail.order_item_list[i].unit, // 单位
                staff: "",
                sales_list: [],
              };
              if (this.orderDetail.order_item_list[i].sales_list) {
                one.sales_list = this.orderDetail.order_item_list[i].sales_list;
                for (
                  let b = 0;
                  b < this.orderDetail.order_item_list[i].sales_list.length;
                  b++
                ) {
                  one.staff +=
                    this.orderDetail.order_item_list[i].sales_list[b].sales_name +
                    " ";
                }
              }
              this.tableData.push(one);
            }
						this.getDetail();
          }
        });
			},
			// 获取详情
			getDetail(){
				let params = {
					orderNumber: this.$route.query.id
				}
				this.$http.get('/api/ReturnOrder/Detail', params).then(res => {
					if (res.code == 0) {
						this.detail = res.data;
  
						this.detail.return_list = []
						this.detail.replace_list = []
						for(let i=0;i<this.detail.return_item_list.length;i++){
						
							let one = {
								activityId: this.detail.return_item_list[i].activity_info&&this.detail.return_item_list[i].activity_info.activity_id,
								activityName: this.detail.return_item_list[i].activity_info&&this.detail.return_item_list[i].activity_info.activity_name,
								goodsDosage: "", // 用量
								goodsId: this.detail.return_item_list[i].goods_id, // 商品id
								goodsName: this.detail.return_item_list[i].goods_name, // 商品名称
								goodsList: [], // children
								goodsType:  this.detail.return_item_list[i].goods_type, // 1:商品；2:服务；3:套餐
								goodsUsage: "", // 用法
								isPay: this.detail.state, // 是否支付
								num:this.detail.return_item_list[i].num, // 数量
								originalPrice: this.detail.return_item_list[i].original_price, // 原价
								price: this.detail.return_item_list[i].buy_price, // 现价
								remark: this.detail.return_item_list[i].remark, // 备注
								model: this.detail.return_item_list[i].sku_value, // 规格
								skuValue: this.detail.return_item_list[i].sku_value, // 规格
								skus: this.detail.return_item_list[i].sku_value, // 规格
								totalMoney: (this.detail.return_item_list[i].num*this.detail.return_item_list[i].price).toFixed(2), // 总价
								unit: this.detail.return_item_list[i].order_item_goods_list&&this.detail.return_item_list[i].order_item_goods_list[0].unit, // 单位
								staff: '',
								validityStopDate:this.detail.return_item_list[i].validity_stop_date
							}
							if(this.tableData[i].goodsId==this.detail.return_item_list[i].goods_id&&this.tableData[i].skuValue==this.detail.return_item_list[i].sku_value){
								one.staff=this.tableData[i].staff
							}
							if(this.detail.return_item_list[i].goods_type==2 || this.detail.return_item_list[i].goods_type==4){ // 服务
								one.tableKey='tableKey_service_one'+Math.random();
								one.bar_code='service'+i+this.detail.return_item_list[i].goods_name;
							}else if(this.detail.return_item_list[i].goods_type==0||this.detail.return_item_list[i].goods_type==1||this.detail.return_item_list[i].goods_type==8){ // 商品
								one.tableKey='tableKey_goods_one'+Math.random();
								one.bar_code='bar_code_goods_one'+Math.random();
							}
							this.detail.return_list.push(one);
						}
						if(this.detail.replace_item_list.length>0){
							for(let i=0;i<this.detail.replace_item_list.length;i++){
								let one = {
									activityId: this.detail.replace_item_list[i].activity_info&&this.detail.replace_item_list[i].activity_info.activity_id,
									activityName: this.detail.replace_item_list[i].activity_info&&this.detail.replace_item_list[i].activity_info.activity_name,
									goodsDosage: "", // 用量
									goodsId: this.detail.replace_item_list[i].goods_id, // 商品id
									goodsName: this.detail.replace_item_list[i].goods_name, // 商品名称
									goodsList: [], // children
									goodsType:  this.detail.replace_item_list[i].goods_type, // 1:商品；2:服务；3:套餐
									goodsUsage: "", // 用法
									isPay: this.detail.state, // 是否支付
									num:this.detail.replace_item_list[i].num, // 数量
									originalPrice: this.detail.replace_item_list[i].price, // 原价
									price: this.detail.replace_item_list[i].buy_price, // 现价
									remark: this.detail.replace_item_list[i].remark, // 备注
									model: this.detail.replace_item_list[i].sku_value, // 规格
									skuValue: this.detail.replace_item_list[i].sku_value, // 规格
									skus: this.detail.replace_item_list[i].sku_value, // 规格
									totalMoney: (this.detail.replace_item_list[i].num*this.detail.replace_item_list[i].price).toFixed(2), // 总价
									unit: this.detail.replace_item_list[i].order_item_goods_list&&this.detail.replace_item_list[i].order_item_goods_list[0].unit, // 单位
									staff: '',
									validityStopDate:this.detail.replace_item_list[i].validity_stop_date
								}
								// for(let b=0;b<this.detail.replace_item_list[i].sales_list.length;b++){
								// 	one.staff+=this.detail.replace_item_list[i].sales_list[b].sales_name+' '
								// }
								if(this.detail.replace_item_list[i].goods_type==2||this.detail.replace_item_list[i].goods_type==4){ // 服务
									one.tableKey='tableKey_service_one'+Math.random();
									one.bar_code='service'+i+this.detail.replace_item_list[i].goods_name;
								}else if(this.detail.replace_item_list[i].goods_type==0||this.detail.return_item_list[i].goods_type==1){ // 商品
									one.tableKey='tableKey_goods_one'+Math.random();
									one.bar_code='bar_code_goods_one'+Math.random();
								}
								this.detail.replace_list.push(one);
							}
						}else{
							this.detail.replace_list = []
						}
					}
				})
			},
			
		}
	}
</script>
<style scoped lang="scss">
.page{
	.pageTitleBox{
	}
	.msg {
		display: flex;
		flex-wrap: wrap;
		background-color: #fff;
		border-radius: 4px;
		.msgItem {
			width: 25%;
			font-size: 16px;
			color: $fontColor;
			display: flex;
			line-height: 40px;
			padding:0 20px;
			box-sizing: border-box;
			border-bottom:1px solid #F2F2F2;
			font-size: 12px;;
			.msgLabel {
				width: 80px;
				text-align: right;
				color: $fontColor;
			}
	
			.msgValue {}
		}
	}
	.pageConBox{
		margin-top:12px;
		min-height: 600px;
	}
}
</style>
